export default [

    {
        path: '',
        name: 'ferramentas',
        redirect: { name: 'ferramentas--home' },
    },

    {
        path: 'home',
        name: 'ferramentas--home',
        component: () => import('@/aplicacao/modulos/ferramentas/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE__FERRAMENTAS' },
    },

    {
        path: 'comunicado-pendencias-gerais',
        name: 'ferramentas--comunicado-pendencias-gerais',
        component: () => import('@/aplicacao/modulos/ferramentas/comunicado-pendencias-gerais/ComunicadoPendenciasGerais'),
        meta: { autenticacao: true, permissao: 'ROLE__FERRAMENTAS__COMUNICADO_PENDENCIAS_GERAIS' },
    },

    {
        path: 'comunicado-pendencias-solicitantes',
        name: 'ferramentas--comunicado-pendencias-solicitantes',
        component: () => import('@/aplicacao/modulos/ferramentas/comunicado-pendencias-solicitantes/ComunicadoPendenciasSolicitantes'),
        meta: { autenticacao: true, permissao: 'ROLE__FERRAMENTAS__COMUNICADO_PENDENCIAS_SOLICITANTES' },
    },

    {
        path: 'de-para-produtos',
        name: 'ferramentas--de-para-produtos',
        component: () => import('@/aplicacao/modulos/ferramentas/de-para-produtos/DeParaProdutos'),
        meta: { autenticacao: true, permissao: 'ROLE__FERRAMENTAS__DE_PARA_PRODUTOS' },
    },

    {
        path: 'de-para-temas',
        name: 'ferramentas--de-para-temas',
        component: () => import('@/aplicacao/modulos/ferramentas/de-para-temas/DeParaTemas'),
        meta: { autenticacao: true, permissao: 'ROLE__FERRAMENTAS__DE_PARA_TEMAS' },
    },

    {
        path: 'gerador-ranking-mensal',
        name: 'ferramentas--gerador-ranking-mensal',
        component: () => import('@/aplicacao/modulos/ferramentas/gerador-ranking-mensal/GeradorRankingMensal'),
        meta: { autenticacao: true, permissao: 'ROLE__FERRAMENTAS__GERADOR_RANKING_MENSAL' },
    },

    {
        path: 'gerador-ranking-anual',
        name: 'ferramentas--gerador-ranking-anual',
        component: () => import('@/aplicacao/modulos/ferramentas/gerador-ranking-anual/GeradorRankingAnual'),
        meta: { autenticacao: true, permissao: 'ROLE__FERRAMENTAS__GERADOR_RANKING_ANUAL' },
    },

    {
        path: 'solicitacao-de-cadastro',
        name: 'ferramentas--solicitacao-de-cadastro',
        component: () => import('@/aplicacao/modulos/ferramentas/solicitacao-de-cadastro/Listagem'),
        meta: { autenticacao: true, permissao: 'ROLE__FERRAMENTAS__SOLICITACOES_DE_CADASTRO' },
    },

]
